import { render, staticRenderFns } from "./CategoriaList.vue?vue&type=template&id=fdf20e52"
import script from "./CategoriaList.vue?vue&type=script&lang=js"
export * from "./CategoriaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports